window._define('utils/responsive', ['app/core', 'common/pubsub', 'jquery'], function (core, pubsub, $) {
    'use strict';

    var points = {
            small: window.matchMedia('only screen and (max-width:  767px)'),
            medium: window.matchMedia('only screen and (min-width: 768px) and (max-width: 991px)'),
            large: window.matchMedia('only screen and (min-width: 992px) and (max-width: 1279px'),
            xlarge: window.matchMedia('only screen and (min-width: 1280px)'),
        },
        callbacks = [];

    function registerCallback(callback) {
        callbacks.push(callback);
    }

    function getCurrent() {
        var found = 'large';

        $.each(points, function (size, mq) {
            if (mq.matches) {
                found = size;
            }
        });

        return found;
    }

    // register event for changes, and broadcast to the app with pubsub
    function _widthChange(mq) {
        var current;

        if (mq.matches) {
            current = getCurrent();

            pubsub.publish(pubsub.EVENT.RESPONSIVE_BREAKPOINT_CHANGE, {
                width: current,
            });

            callbacks.forEach(function (callback) {
                callback(current);
            });
        }
    }

    $.each(points, function (size, mq) {
        mq.addListener(_widthChange);
    });

    return {
        RESPONSIVE_BREAKPOINT_CHANGE: pubsub.EVENT.RESPONSIVE_BREAKPOINT_CHANGE,
        onChange: registerCallback,
        getCurrentWidth: getCurrent,
        isSmall: function () {
            return getCurrent() === 'small';
        },
        isLarge: function () {
            return getCurrent() === 'large';
        },
        isXLarge: function () {
            return getCurrent() === 'xlarge';
        },
    };
});
